import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBrowserTabs: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBrowserTabs"><Path fillRule="evenodd" clipRule="evenodd" d="M22 20H2V4H22V20ZM5 8.5H12V7H5V8.5ZM13 7V8.5H15.5V7H13ZM16.5 8.5H19V7H16.5V8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBrowserTabs;
